import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { FormattedCalendarDate, FormattedMoney } from 'components/Formatters';
import { WarningAlert } from 'components/Alerts';
import { SelfServiceAPI } from 'types';
import { addHours, parseISO } from 'date-fns';

interface FailedScheduledPaymentProps extends Pick<SelfServiceAPI.CreditCardPaymentMethod, 'cardType' | 'lastFourDigits'> {
  paymentDueDate: string | Date;
  failedPaymentDate: string | Date;
  updatePaymentMethodUrl: string;
  total: SelfServiceAPI.Total;
}

const FAILED_PAYMENT_GRACE_PERIOD_HOURS = 72;

export const FailedScheduledPayment = ({
  total,
  cardType,
  lastFourDigits,
  paymentDueDate,
  failedPaymentDate,
  updatePaymentMethodUrl,
}: FailedScheduledPaymentProps) => (
  <WarningAlert>
    <WarningAlert.Heading>
      Please update your payment details before{' '}
      <FormattedCalendarDate date={addHours(parseISO(paymentDueDate.toString()), FAILED_PAYMENT_GRACE_PERIOD_HOURS)} />, or your booking
      will be cancelled.
    </WarningAlert.Heading>
    <WarningAlert.Body>
      We were unable to charge your final scheduled payment of <FormattedMoney {...total} /> to your {cardType ? cardType : 'credit card'}{' '}
      ending in {lastFourDigits} on <FormattedCalendarDate date={failedPaymentDate} />.
      <br />
      Please ensure your payment details are up to date to avoid your booking being cancelled.
    </WarningAlert.Body>
    <WarningAlert.Link to={updatePaymentMethodUrl} onClick={tracking.scheduledPaymentFailedUpdateCreditCard}>
      UPDATE CREDIT CARD
    </WarningAlert.Link>
  </WarningAlert>
);
